import React from 'react';
import { Form2 } from '../primitives/Forms2';
import { useOrganizationsList } from './data/useOrganizationsList';
import { useCRMContext } from './CRMContext';
import { FormControlsForFields, TableForFields } from '../schemed';
import { FormGrid, LoadingIndicator, MoreActionsMenuButton, OccupyFreeSpace, SearchField, SimpleDialog, useWindowHotkey } from '../primitives';
import { IconButton, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { OrganizationEditDrawer } from './OrganizationEditDrawer';
import { CRMMenu } from './Elements/CRMMenu';
import { useProcessQueryParam } from '../../hooks/useProcessQueryParam';
import { MergeOrganizationsPanel } from './Elements/MergeOrganizationsPanel';

interface Props {}

export const OrganizationsPage = (props: Props) => {
  const ctx = useCRMContext();
  const data = useOrganizationsList(ctx.apiPath); // Using your standardized hook pattern

  useWindowHotkey("alt+n", () => data.newRecord.startEditing());

  useProcessQueryParam("id",
    v => data.findOrganization(v).then(record => {
      data.editRecord.startEditing(record);
    }),
  )

  return (<>
    <Form2
      noTitle
      background="panel"
      fitFullHeight
      dimmed={data.editRecord.isEditing}
      formHeaderProps={{
        onClick: () => data.editRecord.cancel(),
      }}
      headerItems={<>
        <CRMMenu title="Компании" current="organizations" />

        <IconButton size="small" color="primary" onClick={() => data.newRecord.startEditing()}>
          <Add />
        </IconButton>

        <OccupyFreeSpace />

        {data.isLoading && <LoadingIndicator sizeVariant="s" />}

        <Typography variant="caption" color="textSecondary" alignSelf="flex-end" style={{ marginBottom: 4}}>
          {data.count.data.total_records}
        </Typography>

        <SearchField
          filter={data.filter.filter}
          setFilter={data.filter.setFilter}
          noButton
          autoFocus
        />
      </>}
      subHeaderItems={<>
        
      </>}
    >
      <TableForFields
        data={data.data}
        fields={[
          ["actions", { label: " ", width: 50 }],
          ["name"],
          ["description"],
        ]}
        onRowClick={r => data.editRecord.startEditing({ ...r })}
        schema={data.schema}
        tailAnchor={data.limitTrigger.pagingAnchor}
        fieldElement={f => {
          switch(f) {
            case "actions":
              if(data.merge.isPanelVisible) {
                return r => <>
                  {r._id !== data.merge.targetOrganization?._id &&
                    !data.merge.sourceOrganizations?.find(o => o._id === r._id) &&
                  <IconButton size="small" onClick={e =>{ e.stopPropagation(); data.merge.addSource(r)}}><Add /></IconButton>}
                </>
              } else {
                return r => (
                  <MoreActionsMenuButton
                    size="small"
                    stopPropagation
                    actions={[
                      ["merge", "Слияние", () => data.merge.startMerge(r)]
                    ]}
                    />
                )
              }
          }
        }}
      />
    </Form2>

    <OrganizationEditDrawer 
      schema={data.schema} 
      editRecord={data.editRecord}
      removeRecord={data.remove.run}
    />

    <SimpleDialog
      {...data.newRecord.dialog}
      dialogTitle="Новая компания"
      save={() => data.newRecord.save()}
      maxWidth="xs"
      noFullscreen
      submitOnModEnter
    >
      {!!data.newRecord.item &&
        <FormGrid columns="1fr" noMargin>
          <FormControlsForFields
            fields={[
              ["name", { controlProps: { autoFocus: true }}],
              ["description", { controlProps: { multiline: true, rows: 3 } }],
            ]}
            schema={data.schema}
            data={data.newRecord.item}
            onChange={(o,c) => data.newRecord.update(c)}
          />
        </FormGrid>}
    </SimpleDialog>

    <MergeOrganizationsPanel
      merge={data.merge}
      onComplete={() => data.reload()}
      />
  </>);
}